export const ONGOING_SWAPS_COUNT_POLLING_INTERVAL = 15000;
